import { colors } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import styled from 'styled-components';

import { useIsMobile } from 'common/hooks/useIsMobile';

type ProgressProps = {
  progress: number;
};

const MOBILE_RESIZE_RATIO = 0.75;

const CircleContainer = styled.div<{ isMobile: boolean }>`
  position: relative;
  display: inline-block;
  width: ${({ isMobile }) => (isMobile ? `${32 * MOBILE_RESIZE_RATIO}px` : '32px')};
  height: ${({ isMobile }) => (isMobile ? `${32 * MOBILE_RESIZE_RATIO}px` : '32px')};
`;

const CircleBackground = styled.circle<{ isMobile: boolean }>`
  fill: none;
  stroke: ${cssThemedValue({ light: colors.pepper8, dark: colors.salt28 })}; /* color-bg-surface */
  stroke-width: ${({ isMobile }) => (isMobile ? `${4 * MOBILE_RESIZE_RATIO}` : '4')};
`;

const CircleProgress = styled.circle<{ isMobile: boolean }>`
  fill: none;
  stroke: ${cssThemedValue({ light: colors.banana100, dark: colors.banana100 })}; /* color-text-support-yellow */
  stroke-width: ${({ isMobile }) => (isMobile ? `${4 * MOBILE_RESIZE_RATIO}` : '4')};
  stroke-linecap: round;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
`;

const CircularProgress = ({ progress }: ProgressProps) => {
  const isMobile = useIsMobile();

  const radius = 16 * (isMobile ? MOBILE_RESIZE_RATIO : 1);
  const normalizedRadius = radius - 4 / 2; // Adjust for stroke width
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <CircleContainer isMobile={isMobile}>
      <svg height={32 * (isMobile ? MOBILE_RESIZE_RATIO : 1)} width={32 * (isMobile ? MOBILE_RESIZE_RATIO : 1)}>
        <CircleBackground r={normalizedRadius} cx={radius} cy={radius} isMobile={isMobile} />
        <CircleProgress
          isMobile={isMobile}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={strokeDashoffset}
        />
      </svg>
    </CircleContainer>
  );
};

export default CircularProgress;
